import gql from 'graphql-tag';

export const DELETE_BILL_OF_QUANTITY_MUTATION = gql`
  mutation DeleteBillOfQuantity($where: BillOfQuantityWhereUniqueInput!) {
    deleteBillOfQuantity(where: $where) {
      id
    }
  }
`;
